const waitTimeMs = (ms: number) =>
	new Promise((resolve: (result: Promise<undefined> | undefined) => void) =>
		setTimeout(resolve, ms),
	);

export const withExponentialBackoffRetries = async <T,>({
	callback,
	totalAttempts,
	baseIntervalMs,
}: {
	callback: (attemptIndex: number, totalAttempts: number) => Promise<T>;
	totalAttempts: number;
	baseIntervalMs: number;
}): Promise<T> => {
	for (let attemptIndex = 0; attemptIndex < totalAttempts; attemptIndex += 1) {
		/* eslint-disable no-await-in-loop */
		try {
			return await callback(attemptIndex, totalAttempts);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			if (attemptIndex + 1 < totalAttempts) {
				// if retry attempts remain, wait time before trying again
				await waitTimeMs(baseIntervalMs * Math.pow(2, attemptIndex));
			} else {
				// else if no more attempts, throw the error
				throw error;
			}
		}
		/* eslint-enable no-await-in-loop */
	}
	throw Error('withExponentialBackoffRetries should not reach');
};
